import { defineMessage } from 'services/localization';

export const messages = {
    defaultDisplayName: defineMessage('unnamed_organisation'),
    userRoleAccountOwner: defineMessage('account_owner_1'),
    userRoleParticipant: defineMessage('user'),
    userRoleAuditor: defineMessage('auditor'),
    userRoleManager: defineMessage('administrator'),
    userRoleWorkflowManager: defineMessage('workflow_manager'),
    userStatusActive: defineMessage('active'),
    userStatusInvited: defineMessage('pending'),
    userStatusRejected: defineMessage('rejected'),
    userStatusNotInvited: defineMessage('not_invited'),
};
